// src/pages/admin/Sandbox.tsx
// Admin "Sandbox" page — a home for ad-hoc test surfaces that don't belong
// in production nav yet. Currently:
//   - Animation: the token-economy animation library (previously its own page)
//   - DB Connections: direct probes against external databases (PE today)
import React, { useState } from 'react';
import { Layers, Database, type LucideIcon } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';
import AnimationSandboxTab from './sandbox/AnimationSandboxTab';
import DbConnectionsTab from './sandbox/DbConnectionsTab';

type TabKey = 'animation' | 'db';

const TABS: { key: TabKey; label: string; icon: LucideIcon }[] = [
  { key: 'animation', label: 'Animation', icon: Layers },
  { key: 'db',        label: 'DB Connections', icon: Database },
];

export default function Sandbox() {
  const { ready, isAdmin } = useAuth();
  const [tab, setTab] = useState<TabKey>('animation');

  if (!ready) return null;
  if (!isAdmin) {
    return (
      <section className="card">
        <div className="hd"><div className="row"><div style={{ fontWeight: 760 }}>Sandbox</div></div></div>
        <div className="bd"><div className="muted">Admin access required.</div></div>
      </section>
    );
  }

  return (
    <div className="page-stack">
      <section className="card">
        <div className="hd">
          <div className="row" style={{ alignItems: 'center', gap: 16 }}>
            <div style={{ fontWeight: 760 }}>Sandbox</div>
            <div style={{ display: 'flex', gap: 6 }}>
              {TABS.map(t => {
                const Icon = t.icon;
                const active = tab === t.key;
                return (
                  <button
                    key={t.key}
                    className={'btn' + (active ? ' primary' : '')}
                    onClick={() => setTab(t.key)}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
                  >
                    <Icon size={14} /> {t.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {tab === 'animation' && <AnimationSandboxTab />}
      {tab === 'db'        && <DbConnectionsTab />}
    </div>
  );
}
